import { useQuery } from '@tanstack/react-query'

import { importSections } from '~/store/di-entity.api.generated'

import { MultiQueryOptions } from '../useMultiQuery'

/**
 * Fetch DI sections and put them in the store.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export const useSectionsQuery = (options?: MultiQueryOptions) => {
    const sectionsQuery = useQuery({
        queryFn: () => importSections({}),
        queryKey: ['sections'],
        enabled: !options?.skip,
        staleTime: options?.staleTime,
        refetchOnWindowFocus: options?.refetchOnWindowFocus,
        // No refetchInterval here as our entities are updated through web socket updates
    })

    return sectionsQuery
}
